import { FC } from 'react'
import clsx from 'clsx'

import Auth from 'store/auth'
import ToggleButton from '../../../parts/toggle-button/toggle-button'

import { A_wf_clickSubscription, originSubscribe } from 'utils/analytics/webinars/webinar_future'
import { A_LOG_REG_HASH, originRegWebinars } from 'utils/analytics/other/registration/registration'

import styles from './webinar-start-info.module.scss'

interface IAgreeButton {
  isActive: boolean
  AData?: {
    id: number
  }
}

const AgreeButton: FC<IAgreeButton> = ({ isActive, AData }: IAgreeButton) => {
  const { isAuthorized } = Auth.useAuth()
  const analyticHandler = () => {
    AData && isAuthorized && A_wf_clickSubscription(originSubscribe.OWN, AData.id)
    if (!isAuthorized) sessionStorage.setItem(A_LOG_REG_HASH, originRegWebinars.SUBFUTURE)
  }
  return (
    <div className={styles.subscribeBlock}>
      {isActive && (
        <p
          className={clsx(styles.subscribeMessage, styles.agreeMessage, {
            [styles.agreeMessageActive]: isActive,
          })}
        >
          Вы записались на вебинар, ждем вас!
        </p>
      )}
      <div className={styles.toggleWrapper}>
        <ToggleButton
          isActive={Boolean(isActive)}
          modificator={clsx({
            [styles.toggleButtonAccented]: !isActive,
          })}
          isAccented
          withPlus={isAuthorized}
          onClick={analyticHandler}
        >
          Хочу смотреть
        </ToggleButton>
      </div>
    </div>
  )
}

export default AgreeButton
